import { render, staticRenderFns } from "./logo-quarternary.vue?vue&type=template&id=66271490&scoped=true"
import script from "./logo-quarternary.vue?vue&type=script&lang=js"
export * from "./logo-quarternary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66271490",
  null
  
)

export default component.exports